<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Update_Details && !Delete_Details">Add FAQs</v-flex>
                    <v-flex v-else-if="Update_Details">Update FAQs</v-flex>
                    <v-flex v-else-if="Delete_Details">Delete FAQs</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text v-if="!Update_Details && !Delete_Details">
                    <v-flex wrap style="padding: 10px;">
                        <v-flex>
                            <v-select item-value='_id' item-text='name' return-object v-model="SelectedCourseDetail" :items="GetCourseDetailList" label="Select Course Title">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Course_Title }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Course_Title }}    
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="FAQ Title" v-model="FAQ_Title"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-flex style="font-size: 14px;font-weight: 400;padding-bottom: 10px">FAQ Description :</v-flex>
                            <vue-editor v-model="FAQ_Description"></vue-editor>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-card-text v-else-if="Update_Details">
                    <v-flex>
                        <v-flex style="font-weight:bold;padding-bottom: 10px;">Course : {{ Current_Course.Course_Title }}</v-flex>
                    </v-flex>
                    <v-layout row>
                        <v-select item-value='FAQ_Id' item-text='name' return-object v-model="Selected_FAQ" :items="Course_FAQs" label="Select FAQ">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.FAQ_Title }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.FAQ_Title }}    
                                </template>
                        </v-select>
                    </v-layout>
                    <v-flex>
                        <v-text-field label="FAQ Title" v-model="Selected_FAQ.FAQ_Title"></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-flex style="font-weight:bold;padding-bottom: 10px;">FAQ Description :</v-flex>
                        <vue-editor id="editor_FAQ" v-model="Selected_FAQ.FAQ_Description"></vue-editor>
                    </v-flex>
                </v-card-text>
                <v-card-text v-else-if="Delete_Details">
                    <v-flex>
                        <v-flex style="font-weight:bold;padding-bottom: 10px;">Course : {{ Current_Course.Course_Title }}</v-flex>
                    </v-flex>
                    <v-layout row>
                        <v-select item-value='FAQ_Id' item-text='name' return-object v-model="Selected_FAQ" :items="Course_FAQs" label="Select FAQ">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.FAQ_Title }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.FAQ_Title }}    
                                </template>
                        </v-select>
                    </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" v-if="!Update_Details && !Delete_Details" @click="SubmitFAQ">Add FAQ</v-btn>
                        <v-btn color="success" v-else-if="Update_Details" @click="UpdateFAQ">Update FAQ</v-btn>
                        <v-btn color="error" v-else-if="Delete_Details" @click="DeleteFAQ">Delete FAQ</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            SelectedCourseDetail    : {},
            FAQ_Title               : "",
            FAQ_Description         : "",
            Update_Details          : false,
            Delete_Details           : false,
            Course_FAQs             : [],
            Selected_FAQ            : {},
            Current_Course          : {}
        }
    },
    computed:{
        GetCourseDetailList(){
            
            return this.$store.getters.GetCourseDetailsList
        }
    },
    methods:{
        CloseDialog(){
            this.ClearForm()
            this.$emit('close')
        },
        SubmitFAQ(){

            let FAQ = {}
            FAQ["Course_Id"]        = this.SelectedCourseDetail["_id"]
            FAQ["FAQ_Title"]        = this.FAQ_Title
            FAQ['FAQ_Description']  = this.FAQ_Description
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/courseFAQs/addcourseFAQs`,FAQ)
                        .then(response =>{
                            
                            this.$store.commit('UpdateCourseFAQs',response["data"]["response"][0])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added FAQ","Color":"green","Close": false });
                            this.ClearForm()
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Adding FAQ","Color":"red","Close": false });
                        })
        },
        UpdateFAQ(){

            let FAQ = {}
            FAQ['Course_Id']                 = this.Current_Course['Course_Id']
            FAQ['FAQ_Id']                    = this.Selected_FAQ['FAQ_Id']
            FAQ["update"]                    = {}
            FAQ['update']['FAQ_Title']       = this.Selected_FAQ['FAQ_Title']
            FAQ['update']['FAQ_Description'] = this.Selected_FAQ['FAQ_Description']
                
            this.$http.post(`${this.$store.getters.GetProductionUrl}/courseFAQs/updatecourseFAQs`,FAQ)
                        .then(response =>{
                            
                            this.$store.commit('UpdateCourseFAQs',response["data"]["response"][0])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated FAQ","Color":"green","Close": false });
                            this.ClearForm()
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Updating FAQ","Color":"red","Close": false });
                        })
        },
        DeleteFAQ(){

            let FAQ = {}
            FAQ['Course_Id']                 = this.Current_Course['Course_Id']
            FAQ['FAQ_Id']                    = this.Selected_FAQ['FAQ_Id']
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/courseFAQs/deletecourseFAQs`,FAQ)
                        .then(response =>{
                            
                            console.log(response)
                            this.$store.commit('UpdateCourseFAQs',response["data"]["response"][0])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated FAQ","Color":"green","Close": false });
                            this.ClearForm()
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Updating FAQ","Color":"red","Close": false });
                        })

        },
        ClearForm(){

            this.SelectedCourseDetail = {}
            this.FAQ_Title            = ""
            this.FAQ_Description      = ""
            this.Selected_FAQ         = {}
            this.Current_Course       = {}
            this.Course_FAQs          = []
            this.Update_Details = false
            this.Delete_Details = false

            
        },
        GetCourseDetailsList(){

            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                        .then(response =>{

                            this.$store.commit('SetCourseDetailList',response["data"]["response"])
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })

        },
        GetFAQs(Course,Type){
            this.Current_Course = Course
            this.Course_FAQs    = Course['FAQs']
            Type == 'Update' ? this.Update_Details = true : this.Delete_Details = true
        }   
    }
}
</script>
<style scoped>

</style>